import React from "react";
import NoData from "../../NoData";
import {withTranslate} from "react-redux-multilingual";

const BranchDayTimesList = ({language, translate, styles, currentBranchDayTimes, currentBranchDayTimesIsLoading, currentBranch, currentTime, currentTimesPageLimit, currentTimesPage, currentBranchDayTimesLimit, currentTimesPageOffset, setPreviousTimesPage, setNextTimesPage, setCurrentTime}) => {
    const branchesDayTimesList = currentBranchDayTimes && currentBranchDayTimes.length ? currentBranchDayTimes.map((time, index) => {
            return (
                <div key={index} className="time-card" onClick={(e) => setCurrentTime(time, e)}
                    /* hidden old offset < shown < new offset */
                     hidden={index < currentTimesPageOffset || index >= (currentTimesPage * currentTimesPageLimit /*  20 */)}>
                    <div className="time-card-body">
                        <span className="time">{time.time}&nbsp;</span>
                        <span className="range">{time.time_range}</span>
                        {/*<hr/>*/}
                        {/*<span className="time">{time.time}</span>*/}
                    </div>
                </div>
            )
        }
    ) : (<NoData image="no-doctors"/>);
    return (
        <div className="times-wrapper"
             hidden={currentBranchDayTimesIsLoading || (currentBranch && currentBranch.pattern === 1)}
             style={styles.slideInRight}>
            <div className="display-flex" style={{justifyContent: "space-between"}}>
                {/*<i className="far fa-clock"></i>*/}
                <p>
                    <span className="bolder">{translate("choose_time") + " "}</span>
                </p>
                <span>{currentTime ? currentTime.time + " " + currentTime.time_range : null}</span>
            </div>
            <div className="flex-container full-width">
                {branchesDayTimesList}
                <p className="pagination-p time-pagination full-width">
                                                                                <span className="pull-left"
                                                                                      hidden={currentTimesPageOffset === 0}
                                                                                      onClick={() => setPreviousTimesPage()}><i
                                                                                    className="fas fa-arrow-alt-circle-left"></i></span>
                    <span className="pull-right"
                          hidden={currentTimesPage * currentTimesPageLimit >= currentBranchDayTimesLimit}
                          onClick={() => setNextTimesPage()}><i className="fas fa-arrow-alt-circle-right"></i></span>
                </p>
            </div>

        </div>
    )
};

export default withTranslate(BranchDayTimesList);